export default "__VITE_ASSET__BSDtAhZd__"